import type { IconData } from '@stacksjs/iconify-core'

export const focusPoints: IconData = {
  "body": "<path fill=\"none\" stroke=\"#2859c5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M13 7s-3.086 0-6.356.193a3.66 3.66 0 0 0-3.45 3.45C3 13.913 3 17 3 17M35 7s3.086 0 6.356.193a3.66 3.66 0 0 1 3.45 3.45C45 13.913 45 17 45 17M35 41s3.086 0 6.356-.193a3.66 3.66 0 0 0 3.45-3.45C45 34.087 45 31 45 31M13 41s-3.086 0-6.356-.193a3.66 3.66 0 0 1-3.45-3.45C3 34.087 3 31 3 31m21-18.5v2m0 6.5v6m3-3h-6m15 0h-2m-10 9.5v2M14 24h-2\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default focusPoints
